var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getHeaders, NUMBER_ASSIGN_TIMEOUT_MS } from "../utils/apiUtils";
import { API_PATHS } from "../types/apiPaths";
export var createCoEditionRequest = function (kyInstance, data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, errorText;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.CO_EDITION_NUMBER_REQUESTS, {
                    json: data,
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.text()];
            case 2:
                errorText = _a.sent();
                throw new Error("Failed to create co-edition request: ".concat(response.status, " ").concat(response.statusText, " - ").concat(errorText));
            case 3: return [2 /*return*/, response.json()];
        }
    });
}); };
export var fetchCoEditionRequests = function (kyInstance_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([kyInstance_1], args_1, true), void 0, function (kyInstance, filters) {
        var productId, statuses, _a, offset, _b, limit, queryParts, baseQuery, searchParams, response, errorText;
        if (filters === void 0) { filters = {}; }
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    productId = filters.productId, statuses = filters.statuses, _a = filters.offset, offset = _a === void 0 ? 0 : _a, _b = filters.limit, limit = _b === void 0 ? 100 : _b;
                    queryParts = [];
                    if (productId)
                        queryParts.push("product.id==\"".concat(productId, "\""));
                    if (statuses === null || statuses === void 0 ? void 0 : statuses.length) {
                        queryParts.push(statuses.length === 1
                            ? "status==\"".concat(statuses[0], "\"")
                            : "(".concat(statuses.map(function (s) { return "status==\"".concat(s, "\""); }).join(" or "), ")"));
                    }
                    baseQuery = queryParts.length > 0 ? queryParts.join(" and ") : "cql.allRecords=1";
                    searchParams = new URLSearchParams();
                    searchParams.set("query", baseQuery);
                    searchParams.set("offset", String(offset));
                    searchParams.set("limit", String(limit));
                    return [4 /*yield*/, kyInstance.get(API_PATHS.CO_EDITION_NUMBER_REQUESTS, {
                            searchParams: searchParams,
                            headers: getHeaders(),
                        })];
                case 1:
                    response = _c.sent();
                    if (!!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.text()];
                case 2:
                    errorText = _c.sent();
                    throw new Error("Failed to fetch co-edition requests: ".concat(response.status, " ").concat(response.statusText, " - ").concat(errorText));
                case 3: return [2 /*return*/, response.json()];
            }
        });
    });
};
export var fetchCoEditionRequestById = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, errorText;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.get("".concat(API_PATHS.CO_EDITION_NUMBER_REQUESTS, "/").concat(encodeURIComponent(id)), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.text()];
            case 2:
                errorText = _a.sent();
                throw new Error("Failed to fetch co-edition request: ".concat(response.status, " ").concat(response.statusText, " - ").concat(errorText));
            case 3: return [2 /*return*/, response.json()];
        }
    });
}); };
export var previewCoEditionAssign = function (kyInstance, requestId, data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, errorText;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post("".concat(API_PATHS.CO_EDITION_NUMBER_REQUESTS, "/").concat(encodeURIComponent(requestId), "/assign/preview"), { json: data, headers: getHeaders(), timeout: NUMBER_ASSIGN_TIMEOUT_MS })];
            case 1:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.text()];
            case 2:
                errorText = _a.sent();
                throw new Error("Failed to preview co-edition assignment: ".concat(response.status, " ").concat(response.statusText, " - ").concat(errorText));
            case 3: return [2 /*return*/, response.json()];
        }
    });
}); };
export var assignCoEditionNumber = function (kyInstance, requestId, data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, errorText;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post("".concat(API_PATHS.CO_EDITION_NUMBER_REQUESTS, "/").concat(encodeURIComponent(requestId), "/assign"), { json: data, headers: getHeaders(), timeout: NUMBER_ASSIGN_TIMEOUT_MS })];
            case 1:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.text()];
            case 2:
                errorText = _a.sent();
                throw new Error("Failed to assign co-edition number: ".concat(response.status, " ").concat(response.statusText, " - ").concat(errorText));
            case 3: return [2 /*return*/, response.json()];
        }
    });
}); };
export var rejectCoEditionRequest = function (kyInstance, requestId, data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, errorText;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post("".concat(API_PATHS.CO_EDITION_NUMBER_REQUESTS, "/").concat(encodeURIComponent(requestId), "/reject"), { json: data, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.text()];
            case 2:
                errorText = _a.sent();
                throw new Error("Failed to reject co-edition request: ".concat(response.status, " ").concat(response.statusText, " - ").concat(errorText));
            case 3: return [2 /*return*/, response.json()];
        }
    });
}); };
var postCoPublisherDecision = function (kyInstance, requestId, decision, data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, errorText;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post("".concat(API_PATHS.CO_EDITION_NUMBER_REQUESTS, "/").concat(encodeURIComponent(requestId), "/").concat(decision), { json: data, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.text()];
            case 2:
                errorText = _a.sent();
                throw new Error("Failed to record co-publisher decision (".concat(decision, "): ").concat(response.status, " ").concat(response.statusText, " - ").concat(errorText));
            case 3: return [2 /*return*/, response.json()];
        }
    });
}); };
/**
 * Consents to a co-edition request awaiting the co-publisher. Called by a user of the
 * co-publisher's organization, or by an agency worker confirming the consent on its behalf.
 */
export var approveCoEditionRequestAsCoPublisher = function (kyInstance, requestId, data) {
    if (data === void 0) { data = {}; }
    return postCoPublisherDecision(kyInstance, requestId, "co-publisher-approve", data);
};
/** Refuses a co-edition request awaiting the co-publisher (co-publisher's users only). */
export var declineCoEditionRequestAsCoPublisher = function (kyInstance, requestId, data) {
    if (data === void 0) { data = {}; }
    return postCoPublisherDecision(kyInstance, requestId, "co-publisher-decline", data);
};
